import i18n from '@/lang/i18n'
import { ConfigurationOntologyForAutomaticValuableConceptResponse } from '@/modules/configurationModule/detail/automation/valuable-concepts/services/configuration-valuable-concepts.dto'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { valuableConceptConfigurationServices } from '@/modules/configurationModule/detail/automation/valuable-concepts/services/configuration-valuable-concepts.service'
import { store } from '@/store/store'

export const columnsDefTextAutomationValuableConceptsGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.sampleType'),
            colId: 'sampleType',
            field: 'sampleType.description',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true,
            filter: false,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.topographicCode'),
            colId: 'topographicCode',
            field: 'topographicCode.description',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true,
            filter: false,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.procedures'),
            colId: 'procedure',
            field: 'procedure.description',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true,
            filter: false,
            sortable: true
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.mostLikelyDiagnoses'),
            colId: 'mostLikelyMorphologicCode',
            field: 'mostLikelyMorphologicCode.description',
            flex: 1,
            minWidth: 250,
            suppressSizeToFit: true,
            filter: false,
            sortable: true
        }
    ]

export interface AutomationValuableConceptsGridState extends CrudModelPaginatorLaboratory<ConfigurationOntologyForAutomaticValuableConceptResponse> {
    labId: number
}
export const initialAutomationValuableConceptsGridState =
    (): AutomationValuableConceptsGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.automation.valuableConcepts',
        columnsDef: columnsDefTextAutomationValuableConceptsGrid(),
        datasource: new PaginatorLaboratoryDatasource(valuableConceptConfigurationServices, store.getters.labId),
        labId: store.getters.labId
    })
